import config from "appConfig";
import { Slide } from "packages/lesson/dist/@types";

import { task as task01 } from "../../../../../task/course-02/lesson-04/task-01";

const task: Slide = {
  title:
    "This figure represents the masked threshold of test tones at different frequencies. The masker is critical-band wide noise (1kHz) presented at different levels (indicated on the chart).",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/04/task/image-1.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
